import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { PickupLocationInformation } from '../components/PickupLocationInformation.js';
import { PickupWarningMessage } from '../components/PickupWarningMessage.js';
import { StoresFinderContainer } from './StoresFinderContainer.js';

const PickupStoresContainer = ({ hideTitle =false , warningMessageOnly =false , selectedStore , onStoreSelect , onShippingModalClose , showEditButton =true  })=>{
    const { getLabel  } = useIntl();
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    React.useEffect(()=>{
        if (!selectedStore) {
            setModalIsOpen(true);
        }
    }, [
        selectedStore
    ]);
    const onPickupModalClose = ()=>{
        setModalIsOpen(false);
        onShippingModalClose === null || onShippingModalClose === void 0 ? void 0 : onShippingModalClose();
    };
    const onPickupModalShow = (event)=>{
        setModalIsOpen(true);
        event && event.preventDefault();
    };
    const labels = React.useMemo(()=>({
            storeFinderAction: getLabel('checkout.storeFinder.action'),
            noSelection: getLabel('checkout.store.selectStore.message'),
            noSelectionLink: getLabel('checkout.store.selectStore.link'),
            title: getLabel('checkout.store.title')
        })
    , [
        getLabel
    ]);
    const handleStoreSelect = React.useCallback((store)=>{
        if (!store) {
            return;
        }
        setModalIsOpen(false);
        onStoreSelect(store);
    }, [
        onStoreSelect
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, modalIsOpen && /*#__PURE__*/ React.createElement(Modal, {
        className: "checkout-step--shipping__modal",
        showIcon: true,
        iconClassName: "checkout-step--shipping__modal__close",
        isOpen: modalIsOpen,
        onModalClose: onPickupModalClose
    }, /*#__PURE__*/ React.createElement(StoresFinderContainer, {
        onPickupStoreSelect: handleStoreSelect,
        showAttributesAsTags: true
    })), selectedStore && !warningMessageOnly ? /*#__PURE__*/ React.createElement(PickupLocationInformation, {
        hideTitle: hideTitle,
        title: labels.title,
        location: selectedStore,
        onPickupModalShow: showEditButton ? onPickupModalShow : undefined
    }) : /*#__PURE__*/ React.createElement(PickupWarningMessage, {
        labels: labels,
        onPickupModalShow: showEditButton ? onPickupModalShow : undefined
    }));
};

export { PickupStoresContainer };
//# sourceMappingURL=PickupStoresContainer.js.map
